import axios from 'axios';

class BackendConnection {
    async doAxiosPost(
        url,
        payload,
        mutateStateCallback,
        successCallback,
        errorCallback,
    ) {
        axios.defaults.withCredentials = true;

        return axios
            .post(url, payload)
            .then(function (response) {
                mutateStateCallback(response.data);

                if (null != successCallback) {
                    return successCallback(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                if (null != errorCallback) {
                    errorCallback(error);
                }
            });
    }

    async doAxiosFormDataPost(
        url,
        formData,
        mutateStateCallback,
        successCallback,
        errorCallback,
    ) {
        axios.defaults.withCredentials = true;

        return axios
            .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(function (response) {
                mutateStateCallback(response.data);

                if (null != successCallback) {
                    return successCallback(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                if (null != errorCallback) {
                    errorCallback();
                }
            });
    }
}

// Export as singleton
export default new BackendConnection();
